import { render, staticRenderFns } from "./taking-order-detail.vue?vue&type=template&id=50c62655&scoped=true&"
import script from "./taking-order-detail.vue?vue&type=script&lang=js&"
export * from "./taking-order-detail.vue?vue&type=script&lang=js&"
import style0 from "./taking-order-detail.vue?vue&type=style&index=0&id=50c62655&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c62655",
  null
  
)

export default component.exports